var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHolidaysTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 0H11C11.1857 0 11.3637 0.0737498 11.495 0.205025C11.6263 0.336301 11.7 0.514348 11.7 0.7V7.7C11.7 7.88565 11.6263 8.0637 11.495 8.19497C11.3637 8.32625 11.1857 8.4 11 8.4H1.2C1.01435 8.4 0.836301 8.32625 0.705025 8.19497C0.57375 8.0637 0.5 7.88565 0.5 7.7V0.7C0.5 0.514348 0.57375 0.336301 0.705025 0.205025C0.836301 0.0737498 1.01435 0 1.2 0ZM1.9 1.4V7H10.3V1.4H1.9ZM11.7 10.5C11.7 10.6857 11.6263 10.8637 11.495 10.995C11.3637 11.1263 11.1857 11.2 11 11.2H1.2C1.01435 11.2 0.836301 11.1263 0.705025 10.995C0.57375 10.8637 0.5 10.6857 0.5 10.5V9.8H11.7V10.5ZM11.7 13.3C11.7 13.4857 11.6263 13.6637 11.495 13.795C11.3637 13.9263 11.1857 14 11 14H1.2C1.01435 14 0.836301 13.9263 0.705025 13.795C0.57375 13.6637 0.5 13.4857 0.5 13.3V12.6H11.7V13.3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidaysTemplates);
export default __webpack_public_path__ + "static/media/holidays-templates.75b698cb.svg";
export { ForwardRef as ReactComponent };